import { useTranslation } from 'react-i18next';
import { PageWrapper } from '@src/components';
import { useDispatch } from 'react-redux';
import { logout } from '@src/store/user/userSlice';
import { useAuth0 } from '@auth0/auth0-react';
import { Button } from 'antd';

interface LogoutProps {
  onClose: () => void;
}
export function Logout({ onClose }: Readonly<LogoutProps>) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { logout: logoutAuth0 } = useAuth0();

  const handleLogOut = () => {
    dispatch(logout(undefined));

    logoutAuth0({
      openUrl() {},
    });
  };

  return (
    <>
      <PageWrapper rootClassName='p-4 bg-wl-background space-y-2 mt-4'>
        <p className='font-bold text-wl-on-background'>
          {t('pages.auth.signOut.areYouSure')}
        </p>
        <p className='text-wl-on-background'>
          {t('pages.auth.signOut.description')}
        </p>
      </PageWrapper>
      <div className='flex justify-between gap-4 mt-8'>
        <Button onClick={onClose} className='btn-secondary w-1/2'>
          {t('buttons.cancel')}
        </Button>
        <Button
          htmlType='submit'
          className='btn-danger w-1/2'
          onClick={handleLogOut}
        >
          {t('buttons.signOut')}
        </Button>
      </div>
    </>
  );
}
